import { Actif } from "../../interfaces";
import React from "react";
interface IndicatorActifsProps {
  loading: boolean;
  actifs: Actif[];
}
const IndicatorActifs = ({ loading, actifs }: IndicatorActifsProps) => {
  return (
    <div className="flex justify-center items-center space-x-5">
      <h2 className="  text-2xl font-medium text-gray-800 ">
        Liste des actifs
      </h2>
      <span className="px-3 py-1  font-bold text-md text-black bg-[#E7EAEE] rounded-full  ">
        {!loading && actifs?.filter((actif) => actif?.verified == false).length}{" "}
        Actif(s) en attente
      </span>
      <span className="px-3 py-1  font-bold text-md text-black bg-[#E7EAEE] rounded-full  ">
        {!loading &&
          actifs?.filter(
            (actif) => actif.in_archive != true && actif?.verified == true
          ).length}{" "}
        Actif(s) validé(s)
      </span>

      <span className="px-3 py-1  font-bold text-md text-black bg-[#E7EAEE] rounded-full  ">
        {!loading &&
          actifs?.filter((actif) => actif?.in_archive == true).length}{" "}
        Actif(s) archivé(s)
      </span>
    </div>
  );
};

export default IndicatorActifs;
